








import { Component, Vue } from 'vue-property-decorator';

const intersectionObserverOptions: IntersectionObserverInit = {
  root: null
};

@Component({
  components: {}
})
export default class LazyLoadingComponent extends Vue {
  private observer: IntersectionObserver | null = null;

  mounted() {
    // @ts-ignore
    if (
      // @ts-ignore
      'IntersectionObserver' in window &&
      // @ts-ignore
      'IntersectionObserverEntry' in window &&
      // @ts-ignore
      'intersectionRatio' in window.IntersectionObserverEntry.prototype
    ) {
      this.observer = new IntersectionObserver(this.onIntersect, intersectionObserverOptions);
      this.observer.observe(this.$refs.target as Element);
    }
  }

  onIntersect(entries: IntersectionObserverEntry[]): void {
    entries.forEach((entry: IntersectionObserverEntry) => {
      if (entry.isIntersecting) {
        this.$emit('intersecting');
      }
    });
  }
}
